import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { translations } from './translations';

const LanguageContext = createContext({ lang: 'fr', setLang: () => {}, t: translations.fr });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'fr';
    return localStorage.getItem('gpe_lang') || 'fr';
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try { localStorage.setItem('gpe_lang', next); } catch (e) { /* noop */ }
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', next);
    }
  }, []);

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', lang);
    }
  }, [lang]);

  const t = translations[lang] || translations.fr;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => useContext(LanguageContext);

export default LanguageContext;
